import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import moment from "moment";
import {
  createComment,
  updateComment,
  setPDFCarrouselIndexWrapper,
  setImagePointsWrapper,
  setVideoTimeWrapper,
  setAudioTimeWrapper
} from "../../actions/CommentAction";
import { Tooltip } from "antd";
import "./emoji-mart.css";
import "./dart_internal.css";
import { handleLinkify } from "../../utils";
import AttachedFile from "./AttachedFile";
import AnsweredComment from "./AnsweredComment";
import CommentAnswerInput from "./CommentAnswerInput";
import CommentEditInput from "./CommentEditInput";
import PdfTag from "./PdfTag/PdfTag";
import "./comment.css";
import { sendNotification } from "../../utils/index";
import DescriptionCommentTag from "./DescriptionCommentTag/DescriptonCommentTag";
import ImageTagV2 from "./ImageTagV2/ImageTagV2";
import VideoTag from "./VideoTag/VideoTag";
import AudioTagV2 from "./AudioTagV2/AudioTagV2";

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultAvatar: "/images/icons/user-icon.svg",
      isEditing: false,
      isMouseOver: false,
      showEditInput: false,
      isAnswering: false,
      showAnswerInput: false
    };
  }

  hanlerOnMouseOver = () => this.setState({ isMouseOver: true });
  handlerOnMouseOut = () => this.setState({ isMouseOver: false });

  setIsAnswering = () => this.setState({ isAnswering: true });
  unsetIsAnswering = () => this.setState({ isAnswering: false });

  setIsEditing = () => this.setState({ isEditing: true });
  unsetIsEditing = () => this.setState({ isEditing: false });

  //muestra respuesta
  toggleShowAnswerInput = () => {
    const { isAnswering, isEditing } = this.state;
    const shouldChange = !isAnswering && !isEditing;
    if (shouldChange) {
      this.setState(state => {
        return {
          ...state,
          showAnswerInput: !state.showAnswerInput,
          showEditInput: false
        };
      }, this.removeInputMentionStyle);
    }
  };

  removeInputMentionStyle = () => {
    const { comment } = this.props;
    const inputElem = document.querySelectorAll(
      `.mentionInput-${comment._id}  input.dart-input-text__input `
    );
    if (inputElem) {
      for (var i = 0; i < inputElem.length; i++) {
        inputElem[i].removeAttribute("style");
      }
    }
  };

  toggleShowEditInput = () => {
    const { isAnswering, isEditing } = this.state;
    const {
      itemSelected: {
        document: { versionNumber }
      }
    } = this.props;
    const {
      comment: { fileTag },
      intl
    } = this.props;
    const shouldChange = !isAnswering && !isEditing;

    if (fileTag) {
      if (shouldChange) {
        if (fileTag.versionNumber === versionNumber) {
          this.setState(state => {
            return {
              ...state,
              showAnswerInput: false,
              showEditInput: !state.showEditInput
            };
          }, this.removeInputMentionStyle);
        } else {
          sendNotification(
            "info",
            intl,
            intl.formatMessage({ id: "its_is_not_same_version_edit_comment" })
          );
        }
      }
    } else if (shouldChange) {
      this.setState(
        state => ({
          ...state,
          showEditInput: !state.showEditInput,
          showAnswerInput: false
        }),
        this.removeInputMentionStyle
      );
    }
  };
  afterSendAnswer = () => {
    this.setState({
      isAnswering: false,
      showAnswerInput: false
    });
  };

  afterSendEditComment = () => {
    this.setState({
      isEditing: false,
      showEditInput: false
    });
  };

  render() {
    const {
      comment,
      commentWhichReplied,
      canCreateCommentDart,
      user,
      intl,
      usersMentions,
      downloadFileComment,
      setPDFCarrouselIndexWrapper,
      setImagePointsWrapper,
      setVideoTimeWrapper,
      setAudioTimeWrapper
    } = this.props;
    const {
      defaultAvatar,
      isMouseOver,
      showAnswerInput,
      showEditInput
    } = this.state;
    const { fileTag } = comment;
    console.log("comment => ", comment);
    const defaultImgAvatar = comment && comment.user_creator && comment.user_creator._id && user && user._id === comment.user_creator._id ? user.avatar : defaultAvatar;
    
    return (
      <React.Fragment>
        <div
          className={`bb-comments-block__item ${
            this.props.clickReference ? "comment-highlight" : ""
          }`}
          key={comment._id}
          ref={this.props.clickReference}
          onMouseOver={this.hanlerOnMouseOver}
          onMouseLeave={this.handlerOnMouseOut}
        >
          <figure>
            <img
              alt="avatar"
              src={
                comment.user_creator.avatar === "" ||
                !comment.user_creator.avatar
                  ? defaultImgAvatar
                  : comment.user_creator.avatar
              }
              ref={img => (this[`img-${comment._id}`] = img)}
              onError={() => (this[`img-${comment._id}`].src = defaultAvatar)}
              width="60.99"
              height="60.99"
              style={{objectFit: "cover", borderRadius: "50%"}}
            />
          </figure>
          <div className="info" style={{ width: "100%" }}>
            <div className="comment-header-wrapper-v2">
              <h3 style={{ marginTop: 0 }}>
                {comment.user_creator.name}
                <span>{moment(comment.createdAt).fromNow()}</span>
              </h3>
              <span className="last-child-margin">
                {showEditInput && (
                  <DescriptionCommentTag
                    message={intl.formatMessage({ id: "editing_comment" })}
                  />
                )}
                {showAnswerInput && (
                  <DescriptionCommentTag
                    message={intl.formatMessage({ id: "answering_comment" })}
                  />
                )}
              </span>
            </div>
            {commentWhichReplied && !showAnswerInput && !showEditInput && (
              <span
                onClick={() =>
                  this.props.scrollToReplyComment(commentWhichReplied._id)
                }
              >
                <AnsweredComment answeredComment={commentWhichReplied} />
              </span>
            )}
            {!showEditInput && (
              <React.Fragment>
                <span
                  className={`show-comment ${
                    comment.position > 0 ? "bold-text " : ""
                  }`}
                >
                  {comment.comment.split("\n").map((c, index) => {
                    if (fileTag && index === 0 && fileTag && !fileTag.imagePoint && !fileTag.videoTime && !fileTag.audioTime) {
                      return (
                        <div key={index} className="line-with-tag">
                          <PdfTag
                            pdfCarouselIndex={fileTag.pageNumber}
                            versionNumber={fileTag.versionNumber}
                            onClick={setPDFCarrouselIndexWrapper}
                          />
                          &nbsp;
                          <p
                            style={
                              comment.type === 2 ? { color: "#0096d6" } : {}
                            }
                            key={index}
                          >
                            &nbsp; {handleLinkify(c)}
                          </p>
                        </div>
                      );
                    }
                    if (fileTag && index === 0 && fileTag && fileTag.imagePoint) {
                      return (
                        <div key={index} className="line-with-tag">
                          <ImageTagV2 
                             imagePoint={fileTag.imagePoint}
                             versionNumber={fileTag.versionNumber}
                             onClick={setImagePointsWrapper}
                          />
                          &nbsp;
                          <p
                            style={
                              comment.type === 2 ? { color: "#0096d6" } : {}
                            }
                            key={index}
                          >
                            &nbsp; {handleLinkify(c)}
                          </p>
                        </div>
                      );
                    }
                    if (fileTag && index === 0 && fileTag && fileTag.videoTime) {
                      return (
                        <div key={index} className="line-with-tag">
                          <VideoTag 
                             time={fileTag.videoTime}
                             versionNumber={fileTag.versionNumber}
                             onClick={setVideoTimeWrapper}
                          />
                          &nbsp;
                          <p
                            style={
                              comment.type === 2 ? { color: "#0096d6" } : {}
                            }
                            key={index}
                          >
                            &nbsp; {handleLinkify(c)}
                          </p>
                        </div>
                      );
                    }
                    if (fileTag && index === 0 && fileTag && fileTag.audioTime) {
                      return (
                        <div key={index} className="line-with-tag">
                          <AudioTagV2 
                             time={fileTag.audioTime}
                             versionNumber={fileTag.versionNumber}
                             onClick={setAudioTimeWrapper}
                          />
                          &nbsp;
                          <p
                            style={
                              comment.type === 2 ? { color: "#0096d6" } : {}
                            }
                            key={index}
                          >
                            &nbsp; {handleLinkify(c)}
                          </p>
                        </div>
                      );
                    }
                    return (
                      <div key={index} className={"line-with-tag"}>
                        {/* aca le pasamos el time del video */}
                        {/* <VideoTag minutes={"23"} time={"04"} /> */}
                        {/* {comment.time && comment.time !== "" && comment.time !== null  && <VideoTag time={comment.time} />}
                        &nbsp; */}
                        <p
                          style={comment.type === 2 ? { color: "#0096d6" } : {}}
                          key={index}
                        >
                          {handleLinkify(c)}
                        </p>
                      </div>
                    );
                  })}
                  {comment.attachedFile && (
                    <AttachedFile attachedFile={comment.attachedFile} />
                  )}
                </span>
              </React.Fragment>
            )}
            {showAnswerInput && (
              <CommentAnswerInput
                comment={comment}
                usersMentions={usersMentions}
                setIsAnswering={this.setIsAnswering}
                unsetIsAnswering={this.unsetIsAnswering}
                afterSendAnswer={this.afterSendAnswer}
              />
            )}
            {showEditInput && (
              <CommentEditInput
                comment={comment}
                usersMentions={usersMentions}
                setIsEditing={this.setIsEditing}
                unsetIsEditing={this.unsetIsEditing}
                afterSendEditComment={this.afterSendEditComment}
              />
            )}
          </div>
          {comment.position > 0 && (
            <div className="actions-content show">
              {isMouseOver && (
                <ul className="action-list flip-in-hor-bottom">
                  {comment && comment.attachedFile && (
                    <Tooltip
                      placement="bottom"
                      title={intl.formatMessage({
                        id: "download_file_comment"
                      })}
                    >
                      <li
                        onClick={() => downloadFileComment("original", comment)}
                      >
                        <span>
                          <img
                            src="/images/icons/download_comment.png"
                            alt="download"
                          />
                        </span>
                      </li>
                    </Tooltip>
                  )}
                  {user._id === comment.userCreator && (
                    <Tooltip
                      placement="bottom"
                      title={intl.formatMessage({
                        id: "edit_comment"
                      })}
                    >
                      <li onClick={this.toggleShowEditInput}>
                        <span>
                          <img src="/images/icons/pen_comment.png" alt="pen" />
                        </span>
                      </li>
                    </Tooltip>
                  )}

                  {user._id === comment.userCreator && (
                    <Tooltip
                      placement="bottom"
                      title={intl.formatMessage({
                        id: "delete_comment"
                      })}
                    >
                      <li
                        onClick={() =>
                          this.props.handleShowModalDeleteComment(true, comment)
                        }
                      >
                        <span>
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 33 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "4px" }}
                          >
                            <path
                              d="M10.4614 12.2165C10.7039 12.4602 11.0226 12.5815 11.3414 12.5815C11.6601 12.5815 11.9788 12.4602 12.2213 12.2165C12.7076 11.7302 12.7076 10.9415 12.2213 10.4553L2.26527 0.489192C1.77903 0.00295153 0.991547 0.00295153 0.505306 0.489192C0.0190648 0.975433 0.0190648 1.76417 0.505306 2.25041L10.4614 12.2165Z"
                              fill="#0096D6"
                            ></path>
                            <path
                              d="M18.0802 16.3189L32.1362 2.2504C32.6225 1.76416 32.6225 0.975425 32.1362 0.489184C31.65 0.0029427 30.8625 -0.212053 30.3763 0.275438L15.4415 15.0089H15.0716V15.4402L0.321827 30.3874C-0.164413 30.8736 -0.0719153 31.6624 0.413076 32.1486C0.655571 32.3923 1.02056 32.5136 1.33931 32.5136C1.65805 32.5136 1.9993 32.3923 2.24179 32.1486L16.309 18.0814L30.37 32.1498C30.6125 32.3936 30.935 32.5148 31.2525 32.5148C31.57 32.5148 31.8912 32.3936 32.1337 32.1498C32.62 31.6636 32.6212 30.8749 32.135 30.3886L18.0802 16.3189Z"
                              fill="#0096D6"
                            ></path>
                          </svg>
                        </span>
                      </li>
                    </Tooltip>
                  )}

                  {canCreateCommentDart && comment.position > 0 && (
                    <Tooltip
                      placement="bottom"
                      title={intl.formatMessage({
                        id: "answer"
                      })}
                    >
                      <li onClick={this.toggleShowAnswerInput}>
                        <span>
                          <img
                            src="/images/icons/reply_comment.png"
                            alt="reply"
                          />
                        </span>
                      </li>
                    </Tooltip>
                  )}
                </ul>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const obj = {
    itemSelected: state.comments.itemSelected,
    itemSelectedFetching: state.comments.itemSelectedFetching,
    user: state.authUser.user,
    workclient: state.client.workclient
  };

  return obj;
};

const mapDispatchToProps = {
  createComment,
  updateComment,
  setPDFCarrouselIndexWrapper,
  setImagePointsWrapper,
  setVideoTimeWrapper,
  setAudioTimeWrapper
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Comment))
);
